import { SVGProps } from 'react'

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_55994_10981)">
      <path
        d="M13.4189 3.46991L14.2812 1.91776C14.4691 1.6186 14.1536 1.2603 13.8474 1.08366C13.5413 0.90702 13.1498 1.01958 12.9845 1.33202L12.2578 2.6191"
        stroke={props.fill || '#fff'}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.11719 5.63784L9.97848 3.83358C10.2009 3.36807 10.611 3.01313 11.1037 2.8604C11.5965 2.70733 12.1354 2.76776 12.5823 3.02575C13.0288 3.28374 13.3506 3.72003 13.4645 4.22339C13.5784 4.72641 13.4764 5.25899 13.1842 5.68433L12.7406 6.33013"
        stroke={props.fill || '#fff'}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.53906 7.69C4.19814 6.50631 6.39553 5.63672 9.00463 5.63672C11.6137 5.63672 13.8111 6.50631 14.4702 7.69"
        fill="white"
      />
      <path
        d="M3.53906 7.69C4.19814 6.50631 6.39553 5.63672 9.00463 5.63672C11.6137 5.63672 13.8111 6.50631 14.4702 7.69"
        stroke={props.fill || '#fff'}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.17188 12.3919V10.1836"
        stroke={props.fill || '#fff'}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8349 10.1826V13.9137C14.8349 14.3702 14.977 14.8151 15.2417 15.187L15.4807 15.523C15.996 16.2468 15.4784 17.2506 14.5896 17.2506H3.41604C2.52719 17.2506 2.00955 16.2468 2.52486 15.523L2.76393 15.187C3.02856 14.8151 3.17066 14.3702 3.17066 13.9137V13.5531"
        stroke={props.fill || '#fff'}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0659 10.205H3.33529C2.99047 10.205 2.71094 9.92551 2.71094 9.58069V8.31429C2.71094 7.96948 2.99047 7.68994 3.33529 7.68994H14.6679C15.0128 7.68994 15.2923 7.96948 15.2923 8.31429V9.58073C15.2923 9.92554 15.0128 10.2051 14.6679 10.2051H11.228"
        stroke={props.fill || '#fff'}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_55994_10981">
        <rect
          width="17"
          height="17"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default SvgComponent
